import { FC } from "react";

import type { Event, Score } from "@tsmono/inspect-common/types";
import { SidebarHeader } from "@tsmono/react/components";

import { SampleScansSidebar } from "./SampleScansSidebar";
import { type MakeCiteUrl } from "./scanReferences";
import styles from "./ScansSidebarPanel.module.css";

interface ScansSidebarPanelProps {
  scores: Record<string, Score>;
  events?: readonly Event[] | null;
  makeCiteUrl: MakeCiteUrl;
  selected: string;
  onSelectedChange: (scanner: string) => void;
  onClose: () => void;
}

/**
 * Docked scans panel — wraps SampleScansSidebar in the shared SidebarHeader so
 * it presents and closes like the SearchPanel it sits alongside.
 */
export const ScansSidebarPanel: FC<ScansSidebarPanelProps> = ({
  scores,
  events,
  makeCiteUrl,
  selected,
  onSelectedChange,
  onClose,
}) => {
  return (
    <div className={styles.container}>
      <SidebarHeader icon="scanner" title="Scans" onClose={onClose} />
      <div className={styles.body}>
        <SampleScansSidebar
          scores={scores}
          events={events}
          makeCiteUrl={makeCiteUrl}
          selected={selected}
          onSelectedChange={onSelectedChange}
        />
      </div>
    </div>
  );
};
